/*
  made.straps colour swatch gallery swap.

  Extends sections/ms-product-configurator.liquid. Picking a colour swatch
  fetches that product's JSON and rebuilds the whole thumbnail strip and the
  main photo, rather than swapping only the main photo and leaving stale
  thumbnails behind.

  Alt text is rebuilt with the images. The section's own handlers change src
  and leave alt alone, which leaves the page describing the colour the
  customer arrived on rather than the one they chose. Here the alt is
  derived from the product title that came back with the images, so it
  always matches what is on screen.

  Edge case: a product with a single image gets no thumbnail strip, so the
  strip and the arrows are hidden rather than rendered empty.
*/
(function () {
  'use strict';

  var token = 0;

  function sized(url, w) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function render(root, images, title) {
    var wrap = root.querySelector('[data-ms-gallery]');
    var main = root.querySelector('#ms-cfg-image');

    if (main && images.length) {
      main.src = sized(images[0], 1200);
      main.alt = title || '';
    }

    if (!wrap) return;

    while (wrap.firstChild) wrap.removeChild(wrap.firstChild);

    images.forEach(function (src, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ms-cfg__thumb' + (i === 0 ? ' is-on' : '');
      b.setAttribute('data-ms-thumb', '');
      b.setAttribute('data-full', sized(src, 1200));
      b.setAttribute('data-alt', title || '');
      b.setAttribute('aria-label', 'View photo ' + (i + 1) + ' of ' + images.length);
      b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');

      var im = document.createElement('img');
      im.src = sized(src, 160);
      im.alt = '';
      im.width = 60;
      im.height = 60;
      im.loading = 'lazy';

      b.appendChild(im);
      wrap.appendChild(b);
    });

    var few = images.length < 2;
    wrap.hidden = few;
    root.querySelectorAll('[data-ms-nav]').forEach(function (n) { n.hidden = few; });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    // Keep the main image's alt honest when a thumbnail is clicked. The
    // section sets src only, so without this the description goes stale.
    var thumb = e.target.closest('[data-ms-thumb]');
    if (thumb) {
      var troot = e.target.closest('[data-ms-cfg]');
      if (troot) {
        var tmain = troot.querySelector('#ms-cfg-image');
        if (tmain && thumb.dataset.alt) tmain.alt = thumb.dataset.alt;
        troot.querySelectorAll('[data-ms-thumb]').forEach(function (t) {
          t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
        });
      }
    }

    var sw = e.target.closest('[data-ms-swatch]');
    if (!sw || !sw.dataset.url) return;

    var root = e.target.closest('[data-ms-cfg]');
    if (!root) return;

    var mine = ++token;
    fetch(sw.dataset.url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (mine !== token) return;
        render(root, (p && p.images) || [], p && p.title);
      })
      .catch(function () {});
  });
})();